import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { ELocalStorageKey, ERouterName } from '/@/types/index'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/' + ERouterName.PILOT
  },
  // pilot
  {
    path: '/' + ERouterName.PILOT,
    name: ERouterName.PILOT,
    component: () => import('/@/pages/page-pilot/pilot-index.vue'),
  },
  {
    path: '/' + ERouterName.PILOT_HOME,
    component: () => import('/@/pages/page-pilot/pilot-home.vue')
  },
  {
    path: '/' + ERouterName.PILOT_MEDIA,
    component: () => import('/@/pages/page-pilot/pilot-media.vue')
  },
  {
    path: '/' + ERouterName.PILOT_LIVESHARE,
    component: () => import('/@/pages/page-pilot/pilot-liveshare.vue')
  },
  {
    path: '/' + ERouterName.PILOT_BIND,
    component: () => import('/@/pages/page-pilot/pilot-bind.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Defense in depth against direct URL navigation to a pilot route with no
// session — without this, pilot-home reads stale localStorage on first paint.
// The 401 interceptor in api/http/request.ts handles the server-side rejection
// case; this guard handles the no-token-at-all case before any request fires.
router.beforeEach((to, from, next) => {
  const isPilotRoute = to.path.startsWith('/' + ERouterName.PILOT_HOME) ||
    to.path.startsWith('/' + ERouterName.PILOT_MEDIA) ||
    to.path.startsWith('/' + ERouterName.PILOT_LIVESHARE) ||
    to.path.startsWith('/' + ERouterName.PILOT_BIND)
  if (isPilotRoute && !localStorage.getItem(ELocalStorageKey.Token)) {
    next({ name: ERouterName.PILOT })
    return
  }
  next()
})

export default router
